import { toRaw } from 'vue';
import { Map as OlMap } from 'ol';
import type { Extent } from 'ol/extent';
import { createEmpty, extend as olExtend, isEmpty as olIsEmpty, boundingExtent } from 'ol/extent';
import { transformExtent as olTransformExtent } from 'ol/proj';
import type { Coordinate } from 'ol/coordinate';

export const getMapAutoExtent = (map: OlMap) => {
  const extent = createEmpty();

  map.getLayers().forEach((mapLayer) => {
    const layerExtent = mapLayer.getExtent();

    if (layerExtent) {
      olExtend(extent, layerExtent);
    } else if ('getSource' in mapLayer) {
      const getSourceFn = mapLayer.getSource;

      if (typeof getSourceFn === 'function') {
        const source = getSourceFn.call(mapLayer);

        if (source && 'getExtent' in source) {
          const getExtentFn = source.getExtent;

          if (typeof getExtentFn === 'function') {
            const sourceExtent = getExtentFn.call(source);
            olExtend(extent, sourceExtent);
          }
        }
      }
    }
  });

  return extent;
};

export const createEmptyExtent = () => {
  return createEmpty();
};

export const mergeExtents = (...extents: Extent[]) => {
  const extent = createEmpty();

  extents.forEach((ext) => olExtend(extent, ext));

  return extent;
};

export const isExtentEmpty = (extent?: Extent) => {
  return !extent || olIsEmpty(extent);
};

export const getExtentFromCoordinates = (coordinates: Coordinate[]) => {
  return boundingExtent(toRaw(coordinates));
};

export const transformExtent = (extent: Extent, sourceProjection: string, destProjection: string) => {
  return olTransformExtent(extent, sourceProjection, destProjection);
};
